function hero4() {
    $('.o-hero-4 .o-hero-4__title')
        .addClass('overflow-hidden')
        .each(function () {
            let words = $(this)
                .html()
                .trim()
                .replace(/\r?\n|\r/g, '')
                .split('<br>');
            $(this)
                .empty()
                .html(function () {
                    for (let i = 0; i < words.length; i++) {
                        if (i === 0) {
                            $(this).append(
                                `<span class="inline-block" data-aos="translateY100-fade-in-up" data-aos-delay="0">${words[i]}</span><br>`,
                            );
                        } else {
                            $(this).append(
                                ` <span class="inline-block" data-aos="translateY100-fade-in-up" data-aos-delay="${i}00">${words[i]}</span><br>`,
                            );
                        }
                    }
                });
        });
}

export default hero4;
